import { useLocation, useNavigate as useRRNavigate } from 'react-router-dom'

export { useSearchParams } from 'react-router-dom'

/** Shim for next/navigation `usePathname`. */
export const usePathname = () => {
  const { pathname } = useLocation()
  return pathname
}

/** Shim for next/navigation `useRouter`. */
export const useRouter = () => {
  const navigate = useRRNavigate()
  return {
    push: (u) => navigate(u),
    replace: (u) => navigate(u, { replace: true }),
    back: () => navigate(-1),
  }
}
